import type { CardInfo } from '@lub0v/santa-utils';
import { useTranslation } from 'react-i18next';
import { GiftIcon } from '@src/components/icons/GiftIcon';
import './ParticipantGiftIndicators.css';

export function participantGifts(card: CardInfo, people: CardInfo[]) {
  const state = (recipient: CardInfo | undefined) =>
    !recipient
      ? 'unknown'
      : recipient.isGiftReceived
        ? 'received'
        : recipient.isGiftOnItsWay
          ? 'sent'
          : 'pending';
  return {
    outgoing: state(people.find((person) => person.id === card.wardId)),
    incoming: state(card),
  };
}

export function ParticipantGiftIcon({
  direction,
  state,
}: {
  direction: 'outgoing' | 'incoming';
  state: ReturnType<typeof participantGifts>['incoming'];
}) {
  return (
    <span
      className={`participant-gifts__item participant-gifts__item--${direction}`}
      data-state={state}
      aria-hidden="true"
    >
      <GiftIcon />
      <span className="participant-gifts__direction">{direction === 'outgoing' ? '↑' : '↓'}</span>
    </span>
  );
}

export function ParticipantGiftIndicators({
  card,
  people,
  onDetails,
}: {
  card: CardInfo;
  people: CardInfo[];
  onDetails: () => void;
}) {
  const { t } = useTranslation();
  const gifts = participantGifts(card, people);
  return (
    <span className="participant-gifts">
      {(['outgoing', 'incoming'] as const).map((direction) => {
        const state = gifts[direction];
        const label = t(`box.organizer.giftIndicators.${direction}.${state}`, {
          name: card.username || t('game.people.hidden'),
        });
        return (
          <button
            key={direction}
            type="button"
            className="participant-gifts__button"
            aria-label={label}
            title={label}
            onClick={onDetails}
          >
            <ParticipantGiftIcon direction={direction} state={state} />
            <span
              className={`participant-gifts__label participant-gifts__label--${direction}`}
              data-state={state}
            >
              {t(`box.organizer.giftIndicators.labels.${direction}.${state}`)}
            </span>
          </button>
        );
      })}
    </span>
  );
}
